import React from "react";
import { Button } from "semantic-ui-react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { activateUser } from "./actions";

const ActivateUser = ({ as: As = Button, user, onActivated, ...props }) => (
  <ModalBuilder
    submitAction={activateUser}
    submitParams={user.id}
    onSubmitted={onActivated}
    renderTrigger={(showModal) => <As onClick={showModal} {...props} />}
    renderModal={(modalProps) => (
      <Modal.Confirmation {...modalProps} header="Activate Account">
        Are you sure you wish to activate the account for {user.firstName}{" "}
        {user.lastName}?
      </Modal.Confirmation>
    )}
  />
);

export default ActivateUser;
